import { Component, Input, ViewEncapsulation } from '@angular/core';
import { OrderingOption } from 'generated/graphql-types';
import { phonesRoute } from 'src/app/app-routing.module';
import { RegisterOptions } from 'src/app/common-components/register/models/register-options';
import { EntityRegisterView } from 'src/app/common-components/register/models/register-view';
import { PhonePrivileges } from '../../models/phone-privileges';
import { PhoneRegisterOptions } from '../../models/phone-register-options';
import { PhoneRegisterListItem } from '../../models/phone-register-results.model';

@Component({
    encapsulation: ViewEncapsulation.None,
    selector: 'ndt-phone-register-view',
    styleUrls: ['./phone-register-view.component.scss'],
    templateUrl: './phone-register-view.component.html',
    standalone: false
})
export class PhoneRegisterViewComponent extends EntityRegisterView<
   PhoneRegisterListItem,
   PhoneRegisterOptions,
   OrderingOption
> {
   protected selectQuickFilters(): (state: object) => RegisterOptions | null {
      return () => null;
   }
   @Input() includeInactive: boolean;

   @Input() phonePrivileges: PhonePrivileges;

   getRouterLink(id: number) {
      return `/${phonesRoute}/${id}`;
   }
}
